import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';

import Spinner from 'components/Spinner';
import QuickSetAddressForm from './QuickSetAddressForm';
import BaseModal from '../BaseModal';
import { findQuickSub, quickSetServiceAddress } from 'actions/quickSubs';

import styles from './styles.module.scss';

class QuickSetSubAddressModal extends Component {
  state = {
    loading: false,
  };

  handleUpdateDevice = (values) => {
    const { sub, quickSetServiceAddress, findQuickSub, closeModal } =
      this.props;

    this.setState({ loading: true });
    return quickSetServiceAddress(sub.id, values)
      .then(() => findQuickSub(sub.id))
      .then(() => {
        closeModal();
        toast.success('Service address updated');
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { sub, isOpen, closeModal } = this.props;
    const { loading } = this.state;

    const initialValues = {
      address1: sub?.service_address?.address1 || '',
      city: sub?.service_address?.city || '',
      state: sub?.service_address?.state || '',
      zip_code: sub?.service_address?.zip_code || '',
    };

    return (
      <BaseModal
        isOpen={isOpen}
        title="Update Service Address"
        onClose={closeModal}
        className={styles.modal}
        confirmBtnText=""
        cancelBtnText=""
      >
        <QuickSetAddressForm
          initialValues={initialValues}
          onSubmit={this.handleUpdateDevice}
        />
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  quickSetServiceAddress,
  findQuickSub,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuickSetSubAddressModal);
